<template>
  <div class="inner">
    <input type="checkbox" :name="name" :id="id" :checked="check" v-model="checked" @change="handleChange" />
    <label :for="id" id="checkbox" :class="checked ? 'reverse' : ''">
      <svg viewBox="0 0 100 100" :stroke="checked ? borderColorActive : borderColor" :style="customStyle" >
        <path class="box" :fill="checked ? fillColorActive : fillColor" d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"/>
        <polyline class="check" points="25.5,53.5 39.5,67.5 72.5,34.5 " />
      </svg>
      <span v-if="text">
        <slot></slot>
        {{ text }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String },
    id: { type: [String, Number] },
    name: { type: String },
    check : { type :Boolean, default: false },
    borderColor : { type : String, default : '#5fa8d3'},
    borderColorActive : { type : String, default : '#fff'},
    fillColor : { type: String, default : "#fff"},
    fillColorActive : { type: String, default : "#5fa8d3"},
    size : { type : Number, default: 1.5}
    
  },
  data() {
    return {
      checked: this.check
    };
  },
  // mounted () {
  //    this.$emit("input",this.check);
  // },
  watch : {
    check(value){
      this.checked = value;
    }
  },
  computed : {
    customStyle(){
      return {
        width : this.size ? this.size + 'rem' : '1.5rem',
        'box-shadow' :  this.checked ? '1px 4px 4px 0px #ededed':'',
        'background-color' :  this.checked ? 'transparent' : 'transparent'
      }
    }
  },
  methods: {
    handleChange(event) {
      // this.checked = event.target.value;
      this.$emit("handleCheck", event.target);
      this.$emit("input", event.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #5fa8d3;

.inner {
  border-radius: 0.3em;
  // width: 200px;
  width: 100%;
}
label {
  margin : 0;
}
input[type="checkbox"] {
  display: none;
  pointer-events: none;

  & + label {
    cursor: pointer;
    font-size: 15px;
    display: grid;
    grid-template-columns: auto 3fr;

    svg {
      // width: 1.5em;
      stroke-width: 5;
      // background-color:#83838342;

      .box {
        stroke-dasharray: 320;
        stroke-dashoffset: 0;
      }
      .check {
        stroke-dasharray: 70;
        stroke-dashoffset: 70;
        fill: none;
      }
    }

    span {
      // padding-top: 0.3em;
      margin-left: 0.3em;
    }
  }

  &:checked + label {
    .box {
      stroke-dashoffset: 320;
      transition: stroke-dashoffset 0.3s linear;
    }
    .check {
      stroke-dashoffset: 0;
      transition: stroke-dashoffset 0.3s linear;
    }
  }
}

.reverse {
  .box {
    stroke-dashoffset: 0;
    transition: stroke-dashoffset 0.3s linear;
  }
  .check {
    stroke-dashoffset: 70;
    transition: stroke-dashoffset 0.3s linear;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/global/CheckBox.vue